/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Event_Style_Summary_Position_AriaInputs */

const en_event_style_summary_position_aria = /** @type {(inputs: Event_Style_Summary_Position_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vertical position: ${i?.label}`)
};

const fr_event_style_summary_position_aria = /** @type {(inputs: Event_Style_Summary_Position_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Position verticale : ${i?.label}`)
};

const de_event_style_summary_position_aria = /** @type {(inputs: Event_Style_Summary_Position_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vertikale Position: ${i?.label}`)
};

const it_event_style_summary_position_aria = /** @type {(inputs: Event_Style_Summary_Position_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Posizione verticale: ${i?.label}`)
};

const ru_event_style_summary_position_aria = /** @type {(inputs: Event_Style_Summary_Position_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Вертикальное положение: ${i?.label}`)
};

const es_event_style_summary_position_aria = /** @type {(inputs: Event_Style_Summary_Position_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Posición vertical: ${i?.label}`)
};

const zh_cn2_event_style_summary_position_aria = /** @type {(inputs: Event_Style_Summary_Position_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`垂直位置：${i?.label}`)
};

const ja_event_style_summary_position_aria = /** @type {(inputs: Event_Style_Summary_Position_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`垂直位置: ${i?.label}`)
};

const hi_event_style_summary_position_aria = /** @type {(inputs: Event_Style_Summary_Position_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ऊर्ध्वाधर स्थिति: ${i?.label}`)
};

const pt_pt2_event_style_summary_position_aria = /** @type {(inputs: Event_Style_Summary_Position_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Posição vertical: ${i?.label}`)
};

/**
* | output |
* | --- |
* | "Vertical position: {label}" |
*
* @param {Event_Style_Summary_Position_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_style_summary_position_aria = /** @type {((inputs: Event_Style_Summary_Position_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Style_Summary_Position_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_style_summary_position_aria(inputs)
	if (locale === "de") return de_event_style_summary_position_aria(inputs)
	if (locale === "it") return it_event_style_summary_position_aria(inputs)
	if (locale === "ru") return ru_event_style_summary_position_aria(inputs)
	if (locale === "es") return es_event_style_summary_position_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_event_style_summary_position_aria(inputs)
	if (locale === "ja") return ja_event_style_summary_position_aria(inputs)
	if (locale === "hi") return hi_event_style_summary_position_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_event_style_summary_position_aria(inputs)
	return en_event_style_summary_position_aria(inputs)
});